import * as React from "react";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { Alphanumeric } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { PensionArrangementType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { TransferType } from "../../../../../../../Wrap/Constants/Enums/Domain/TransferType";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { ExternalPensionProtection } from "../../../../../../../Wrap/Models/Domains/Transfer/Pension/ExternalPensionProtection";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { ValidatorContents } from "../../../../../Common/ValidatorHelper";
import { CedingTypeArrays, CedingTypeMap } from "../../../NewBusinessWizard/Resource/Contents";
import { SubAccountTypeHelper } from "../../Helpers/SubAccountTypeHelper";
import { datePickerOptions, DpcQuestionText, processTypeEnum } from "../../Resource/Contents";
import { CedingScheme } from "./CedingScheme";
import { ReRegInvestmentSeletion } from "./ReRegInvestmentSeletion";
import { PensionType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { SubAccountActionIndicators } from "../../../../../../../Wrap/Models/Models/Shared/SubAccountActionIndicators";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";

interface ISingleTransferInSIPP extends IProcessComponentProps {
    isPost: boolean;
    index: number;
    data: any;
    subAccountType: SubAccountType;
    jouneryType: processTypeEnum;
    HasExistingSIPP?: boolean;
    accountServiceProposition: ServiceProposition;
    selectedProducts?: Array<SubAccountActionIndicators>;
}

export class SingleTransferInSIPP extends ProcessComponent<
    ISingleTransferInSIPP,
    {
        //temp soultion
        showEstimatedCurrentYearSubscriptions: boolean;
    }
> {
    constructor(props: ISingleTransferInSIPP) {
        super(props);
        this.state = {
            //temp soultion
            showEstimatedCurrentYearSubscriptions: false,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        if (
            (this.props.jouneryType == processTypeEnum.NewBusinessExistingClient ||
                this.props.jouneryType == processTypeEnum.NewQuoteExistingClient) &&
            this.props.HasExistingSIPP
        ) {
            this.props.onChange({ PensionSource: PensionArrangementType.Crystallised });
        }
        if (
            !this.props.data?.IncomePaymentDetails?.LastGadReviewDate &&
            SubAccountTypeHelper.isOnPlatformPension(this.props.subAccountType)
        ) {
            this.onDataChange(
                this.props.onChange,
                { LastGadReviewDate: JsonDateParser.toJsonDateNoOffset(new Date()) },
                this.props.data,
                "IncomePaymentDetails"
            );
        }
    }

    render() {
        const { data, onChange, subAccountType, jouneryType, selectedProducts } = this.props;
        const isImmediateTaxFreeLumpSum =
            selectedProducts?.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType))
                ?.PensionType == PensionType.ImmediateTaxFreeLumpSum;
        return (
            <>
                {" "}
                {isImmediateTaxFreeLumpSum && (
                    <RadiosEditor
                        cssWrapper="rg-150 mb-20"
                        options={[PensionArrangementType.Accumulation]}
                        getText={(v) => "Pre-retirement"}
                        onChange={(v) => onChange({ PensionSource: v })}
                        validationRules={[
                            {
                                errorMessage: "Can not select pre-retirement",
                                validator: (v) => {
                                    return v == PensionArrangementType.Accumulation && this.props.isPost ? false : true;
                                },
                            },
                        ]}
                        label={"Pension source"}
                        selected={
                            (this.props.jouneryType == processTypeEnum.NewBusinessExistingClient ||
                                this.props.jouneryType == processTypeEnum.NewQuoteExistingClient) &&
                            this.props.HasExistingSIPP
                                ? PensionArrangementType.Crystallised
                                : data?.PensionSource
                        }
                        disabled={
                            (this.props.jouneryType == processTypeEnum.NewBusinessExistingClient ||
                                this.props.jouneryType == processTypeEnum.NewQuoteExistingClient) &&
                            this.props.HasExistingSIPP
                        }
                        required="Please select pension source"
                    />
                )}
                {!isImmediateTaxFreeLumpSum && (
                    <RadiosEditor
                        cssWrapper="rg-150 mb-20"
                        options={
                            jouneryType == processTypeEnum.topUpWithITFLS
                                ? [PensionArrangementType.Accumulation]
                                : [PensionArrangementType.Accumulation, PensionArrangementType.Crystallised]
                        }
                        getText={(v) =>
                            v == PensionArrangementType.Accumulation ? "Pre-retirement" : "Post-retirement"
                        }
                        onChange={(v) => onChange({ PensionSource: v })}
                        validationRules={[
                            {
                                errorMessage: "Can not select pre-retirement",
                                validator: (v) => {
                                    return v == PensionArrangementType.Accumulation && this.props.isPost ? false : true;
                                },
                            },
                        ]}
                        label={"Pension source"}
                        selected={
                            (this.props.jouneryType == processTypeEnum.NewBusinessExistingClient ||
                                this.props.jouneryType == processTypeEnum.NewQuoteExistingClient) &&
                            this.props.HasExistingSIPP
                                ? PensionArrangementType.Crystallised
                                : data?.PensionSource
                        }
                        disabled={
                            (this.props.jouneryType == processTypeEnum.NewBusinessExistingClient ||
                                this.props.jouneryType == processTypeEnum.NewQuoteExistingClient) &&
                            this.props.HasExistingSIPP
                        }
                        required="Please select pension source"
                    />
                )}
                <RadiosEditor
                    cssWrapper="rg-150 mt-15 mb-10"
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) =>
                        this.onDataChange(onChange, { IsDisqualifyingPensionCredits: v }, data, "PensionDetails")
                    }
                    selected={data?.PensionDetails?.IsDisqualifyingPensionCredits}
                    label={DpcQuestionText}
                    required="Please select"
                />
                {data?.PensionSource == PensionArrangementType.Accumulation &&
                    jouneryType !== processTypeEnum.Quote &&
                    this.renderBlockTransfer(data?.Protection, (changes) =>
                        this.onDataChange(onChange, changes, data, "Protection")
                    )}
                {data?.PensionSource == PensionArrangementType.Crystallised && (
                    <>
                        <RadiosEditor
                            cssWrapper="rg-150 mb-20"
                            options={[DrawdownType.Capped, DrawdownType.Flexible]}
                            getText={(v) => (v == DrawdownType.Flexible ? "Flexi" : "Capped")}
                            onChange={(v) =>
                                onChange({
                                    DrawdownType: v,
                                    IncomePaymentDetails: {
                                        LastGadReviewDate: JsonDateParser.toJsonDateNoOffset(new Date()),
                                    },
                                })
                            }
                            label={"Drawdown type"}
                            selected={data?.DrawdownType}
                            required="Please select drawdown type"
                        />
                        {data?.DrawdownType == DrawdownType.Capped && (
                            <>
                                <MoneyTextBoxEditor
                                    cssWrapper="control-size-245"
                                    label={"GAD maximum"}
                                    currency={data?.IncomePaymentDetails?.GadMaximum?.Currency || CurrencyCode.GBP}
                                    onChange={(v) =>
                                        this.onDataChange(
                                            onChange,
                                            { GadMaximum: { Amount: v, Currency: CurrencyCode.GBP } },
                                            data,
                                            "IncomePaymentDetails"
                                        )
                                    }
                                    value={data?.IncomePaymentDetails?.GadMaximum?.Amount}
                                    required={"Please enter GAD maximum"}
                                    validationRules={[
                                        {
                                            errorMessage: "GAD maximum value must be > 0",
                                            validator: (v) => v > 0,
                                        },
                                    ]}
                                />
                                <MoneyTextBoxEditor
                                    cssWrapper="control-size-245"
                                    label={"Income taken to date"}
                                    currency={
                                        data?.IncomePaymentDetails?.CurrentYearIncome?.Currency || CurrencyCode.GBP
                                    }
                                    onChange={(v) =>
                                        this.onDataChange(
                                            onChange,
                                            { CurrentYearIncome: { Amount: v, Currency: CurrencyCode.GBP } },
                                            data,
                                            "IncomePaymentDetails"
                                        )
                                    }
                                    value={data?.IncomePaymentDetails?.CurrentYearIncome?.Amount}
                                    required={"Please enter Income taken to date"}
                                />
                                <DatePicker
                                    formGroupCssWrapper="control-size-245"
                                    selected={JsonDateParser.toDateNoOffset(
                                        data?.IncomePaymentDetails?.LastGadReviewDate
                                    )}
                                    label={"Last mandatory review date"}
                                    defaultValue={JsonDateParser.toDateNoOffset(
                                        data?.IncomePaymentDetails?.LastGadReviewDate
                                    )}
                                    onChange={(v) =>
                                        this.onDataChange(
                                            onChange,
                                            { LastGadReviewDate: JsonDateParser.toJsonDateNoOffset(v) },
                                            data,
                                            "IncomePaymentDetails"
                                        )
                                    }
                                    required={"Please enter Last mandatory review date"}
                                    {...datePickerOptions}
                                />
                            </>
                        )}
                    </>
                )}
                {jouneryType !== processTypeEnum.Quote && (
                    <RadiosEditor
                        cssWrapper="rg-150  mb-0"
                        options={[true, false]}
                        getText={(v) => (v ? "Full" : "Partial")}
                        onChange={(v) => onChange({ FullTransfer: v })}
                        selected={data?.FullTransfer}
                        label={"Full or partial"}
                        required="Please select"
                    />
                )}
                <CedingScheme
                    data={data?.ProviderDetails}
                    onChange={(v) => this.onDataChange(onChange, v, data, "ProviderDetails")}
                    onRef={(ref) => this.appendChild(ref)}
                    type={subAccountType}
                    showErrorMsgPopUp={(msg, showNow) => this.props.showErrorMsgPopUp(msg, showNow)}
                    index={this.props.index}
                />
                {jouneryType !== processTypeEnum.Quote && (
                    <>
                        <SelectEditor
                            cssWrapper="control-size-430 mt-25 mb-16"
                            label="Ceding type"
                            options={CedingTypeArrays}
                            getText={(v) => {
                                return CedingTypeMap[v];
                            }}
                            placeholder="Please select"
                            required="Please select ceding type"
                            selected={data?.PensionDetails?.ExternalPensionSchemeType}
                            onChange={(v) =>
                                this.onDataChange(onChange, { ExternalPensionSchemeType: v }, data, "PensionDetails")
                            }
                        />
                        <TextBoxEditor
                            cssWrapper="control-size-430"
                            label={"Account number"}
                            required="Please enter account number"
                            value={data?.AccountOrPlanNumber}
                            onChange={(v) => this.props.onChange({ AccountOrPlanNumber: v })}
                            regex={{
                                errorMessage: ValidatorContents.AlphaNumericOnly,
                                value: Alphanumeric,
                            }}
                        />
                    </>
                )}
                {data?.PensionSource == PensionArrangementType.Crystallised && (
                    <RadiosEditor
                        cssWrapper="rg-150 mt-28 mb-20"
                        options={jouneryType == processTypeEnum.topUpWithITFLS ? [false] : [true, false]}
                        getText={(v) => (v ? "Yes" : "No")}
                        onChange={(v) =>
                            this.onDataChange(onChange, { IsDependentsPension: v }, data, "PensionDetails")
                        }
                        selected={data?.PensionDetails?.IsDependentsPension}
                        label={"Dependent's pension"}
                        required="Please select"
                    />
                )}
                <h4>Transfer type</h4>
                {isImmediateTaxFreeLumpSum && (
                    <RadiosEditor
                        cssWrapper="radio-group rg-150 second-child-160 mb-15"
                        options={[TransferType.Cash]}
                        getText={(v) => "Cash"}
                        onChange={(v) => onChange({ TransferType: v })}
                        selected={data?.TransferType}
                        required="Please select transfer type"
                    />
                )}
                {!isImmediateTaxFreeLumpSum && (
                    <RadiosEditor
                        cssWrapper="radio-group rg-150 second-child-160 mb-15"
                        options={
                            jouneryType == processTypeEnum.topUpWithITFLS
                                ? [TransferType.Cash]
                                : [TransferType.Cash, TransferType.InSpecie]
                        }
                        getText={(v) => (v == TransferType.Cash ? "Cash" : "Re-register assets")}
                        onChange={(v) => onChange({ TransferType: v })}
                        selected={data?.TransferType}
                        required="Please select transfer type"
                    />
                )}
                {data?.TransferType == TransferType.Cash && (
                    <MoneyTextBoxEditor
                        cssWrapper="control-size-180 pb-20"
                        label={"Cash value"}
                        currency={CurrencyCode.GBP}
                        onChange={(v) => onChange({ CurrentValue: { Amount: v, Currency: CurrencyCode.GBP } })}
                        value={data?.CurrentValue?.Amount}
                        validationRules={[
                            {
                                errorMessage: "Single payment value must be > 0",
                                validator: (v) => v > 0,
                            },
                        ]}
                        required={"Please enter cash value"}
                    />
                )}
                {jouneryType !== processTypeEnum.Quote && (
                    <RadiosEditor
                        cssWrapper="rg-150 mb-16 mt-16"
                        selected={data?.PersonalRecommendations?.IsTransferRecommendationGiven}
                        options={[true, false]}
                        getText={(v) => (v ? "Yes" : "No")}
                        label={"Has a personal recommendation been given for this transfer?"}
                        onChange={(v) =>
                            this.onDataChange(
                                onChange,
                                { IsTransferRecommendationGiven: v },
                                data,
                                "PersonalRecommendations"
                            )
                        }
                        required={"Please select"}
                    />
                )}
                {data?.PersonalRecommendations?.IsTransferRecommendationGiven && jouneryType !== processTypeEnum.Quote && (
                    <>
                        <RadiosEditor
                            cssWrapper="rg-150 mb-16"
                            selected={data?.PersonalRecommendations?.IsTransferAdvised && true}
                            options={[true, false]}
                            getText={(v) => (v ? "Yes" : "No")}
                            label={"Did this recommendation advise the customer to proceed with this transfer?"}
                            onChange={(v) =>
                                this.onDataChange(onChange, { IsTransferAdvised: v }, data, "PersonalRecommendations")
                            }
                            required={"Please select"}
                        />
                        <RadiosEditor
                            cssWrapper="rg-150 mb-16"
                            selected={data?.PersonalRecommendations?.IsContingentChargingUsed}
                            options={[true, false]}
                            getText={(v) => (v ? "Yes" : "No")}
                            label={"Was contingent charging used for this advice?"}
                            onChange={(v) =>
                                this.onDataChange(
                                    onChange,
                                    { IsContingentChargingUsed: v },
                                    data,
                                    "PersonalRecommendations"
                                )
                            }
                            required={"Please select"}
                        />
                    </>
                )}
                {data?.TransferType == TransferType.InSpecie && (
                    <>
                        <ReRegInvestmentSeletion
                            index={this.props.index}
                            isInternal={false}
                            data={data?.Instruments}
                            onChange={(changes) => onChange({ Instruments: changes })}
                            onRef={(ref) => this.appendChild(ref)}
                            type={this.props.subAccountType}
                            modelData={data}
                            onReregValueChange={(v) =>
                                onChange({ ReRegisterValue: { Amount: v, Currency: CurrencyCode.GBP } })
                            }
                            accountServiceProposition={this.props.accountServiceProposition}
                        />
                        <MoneyTextBoxEditor
                            label="Residual cash value"
                            cssWrapper="control-size-180"
                            currency={data?.ReRegisterValue?.Currency || CurrencyCode.GBP}
                            value={data?.ReRegisterValue?.Amount || 0}
                            onChange={(v) => onChange({ ReRegisterValue: { Amount: v, Currency: CurrencyCode.GBP } })}
                            infoText="This value should include all assets that are unavailable for re-registration, plus any residual cash holdings."
                        />
                    </>
                )}
            </>
        );
    }

    private renderBlockTransfer(data: ExternalPensionProtection, onChange) {
        return (
            <RadiosEditor
                cssWrapper="rg-150 mb-16"
                selected={data?.BlockTransferProtection?.HasProtection}
                options={[true, false]}
                getText={(v) => (v ? "Yes" : "No")}
                label={"Block transfer"}
                onChange={(v) => this.onDataChange(onChange, { HasProtection: v }, data, "BlockTransferProtection")}
                required={"Please select block transfer"}
            />
        );
    }
}
